module.exports = __webpack_public_path__ + "media/images/modal-close-w-e48f1bdb0789e32b12365778b21aa4b6.png";